// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vx_a bhb_b bhb_ux"};